import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUP_LOAD_BY_ID,
    ACTION_TRIALGROUP_LOAD,
    ACTION_TRIALGROUPS_LOAD_BY_GROUP_ID,

    ACTION_TRIALGROUP_SAVE,

    ACTION_TRIALGROUP_CREATE,

    ITrialGroupLoadAction,
    ITrialGroupLoadByIdAction,
    ITrialGroupLoadFailureAction,
    ITrialGroupLoadSuccessAction,

    ITrialGroupSaveAction,
    ITrialGroupSaveSuccessAction,
    ITrialGroupSaveFailureAction,

    ITrialGroupCreateAction,
    ITrialGroupCreateSuccessAction,
    ITrialGroupCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,
    ITrialGroupsLoadByGroupIdAction,
    ACTION_TRIALGROUPS_LOAD_BY_TRIAL_ID,
    ITrialGroupsLoadByTrialIdAction,
} from "../actions/trialGroup";
import { trialGroupsApi } from "../services/trialGroups";


export const
    getTrialGroupsEpic = (action$): Observable<ITrialGroupLoadSuccessAction | ITrialGroupLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUP_LOAD)
            .mergeMap((_action: ITrialGroupLoadAction) => {
                return trialGroupsApi
                    .getTrialGroups()
                    .map(response =>
                        LoadSuccess(response.trialGroups, undefined, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupsByIdEpic = (action$): Observable<ITrialGroupLoadSuccessAction | ITrialGroupLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUP_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupLoadByIdAction) => {
                return trialGroupsApi
                    .getTrialGroupById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroup, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupsByGroupIdEpic = (action$): Observable<ITrialGroupLoadSuccessAction | ITrialGroupLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPS_LOAD_BY_GROUP_ID)
            .mergeMap((action: ITrialGroupsLoadByGroupIdAction) => {
                return trialGroupsApi
                    .getTrialGroupsByGroupId(action.groupId)
                    .map(response =>
                        LoadSuccess(response.trialGroups, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupsByTrialIdEpic = (action$): Observable<ITrialGroupLoadSuccessAction | ITrialGroupLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPS_LOAD_BY_TRIAL_ID)
            .mergeMap((action: ITrialGroupsLoadByTrialIdAction) => {
                return trialGroupsApi
                    .getTrialGroupsByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialGroups, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupEpic = (action$): Observable<ITrialGroupSaveSuccessAction | ITrialGroupSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUP_SAVE)
            .mergeMap((action: ITrialGroupSaveAction) => {
                return trialGroupsApi
                    .setTrialGroup(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroup, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupEpic = (action$): Observable<ITrialGroupCreateSuccessAction | ITrialGroupCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUP_CREATE)
            .mergeMap((action: ITrialGroupCreateAction) => {
                return trialGroupsApi
                    .createTrialGroup(action.trialId)
                    .map(response =>
                        CreateSuccess(response.trialGroup, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }